module.exports = __webpack_public_path__ + "front/img/4.0e4d99e1.png";